import Button from '../../../../components/ui/Button';

/**
 * Reset password modal for a team member. Password validation runs in
 * the parent handler (handleResetPasswordSubmit in Team.jsx); this
 * component only renders the form and forwards events via props.
 */
export default function TeamResetPasswordModal({
  resetPasswordUser,
  resetPasswordValue,
  setResetPasswordValue,
  onClose,
  onSubmit,
  resetPasswordMutation,
}) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal team-invite-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Reset Password for {[resetPasswordUser.firstName, resetPasswordUser.lastName].filter(Boolean).join(' ') || resetPasswordUser.email}</h2>
        <p className="text-muted" style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
          This will set a new temporary password and force the user to update it on next login.
        </p>
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label>New password</label>
            <input
              type="password"
              value={resetPasswordValue}
              onChange={(e) => setResetPasswordValue(e.target.value)}
              className="form-control team-input-thumb"
              placeholder="Min 12 characters"
              minLength={12}
              required
              autoComplete="new-password"
            />
          </div>
          <div className="form-actions">
            <Button
              type="button"
              className="team-btn-thumb"
              onClick={onClose}
              disabled={resetPasswordMutation.isLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="team-btn-thumb"
              disabled={resetPasswordMutation.isLoading || resetPasswordValue.length < 12}
            >
              {resetPasswordMutation.isLoading ? 'Resetting…' : 'Reset password'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
